import React, { memo, useCallback, useMemo } from "react";
import Select from "@8x8/oxygen-select";
import { flexRender } from "@tanstack/react-table";

const TOGGLE_ALL = "toggleAll";
const toggleAllColumnsOption = () => ({
  value: TOGGLE_ALL,
  label: "Toggle All",
});

const toSelector = (column) => ({
  value: column.id,
  label: flexRender(column?.columnDef?.header, { column }),
});

const columnVisibilityReducer = (acc, { value }) => {
  acc[value] = false;
  return acc;
};

export const defaultHiddenColumnDefReducer = (acc, column) => {
  if (column.columnDef.defaultHidden) {
    acc[column.id] = false;
  }
  return acc;
};

const ColumnSelector = ({
  allColumns,
  columnVisibility,
  setColumnVisibility,
}) => {
  const columnOptions = useMemo(
    () => allColumns.filter((column) => column.getCanHide()).map(toSelector),
    [allColumns]
  );

  const selectedColumns = useMemo(
    () =>
      allColumns
        .filter((column) => column.getCanHide() && column.getIsVisible())
        .map(toSelector),
    [allColumns, columnVisibility]
  );
  const handleColumnsChange = useCallback(
    (selectedOptions) => {
      const visibleColumnIds = selectedOptions.map((option) => option.value);

      if (visibleColumnIds.includes(TOGGLE_ALL)) {
        // Subtract 1 to account for the toggle all option
        const areAllVisible =
          selectedOptions.length - 1 === columnOptions.length;
        setColumnVisibility(
          areAllVisible ? columnOptions.reduce(columnVisibilityReducer, {}) : {}
        );
        return;
      }

      const invisibleColumnIds = columnOptions.filter(
        ({ value }) => !visibleColumnIds.includes(value)
      );
      setColumnVisibility(
        invisibleColumnIds.reduce(columnVisibilityReducer, {})
      );
    },
    [selectedColumns, columnOptions, setColumnVisibility]
  );

  const options = [
    toggleAllColumnsOption(),
    { label: "Columns", options: columnOptions },
  ];

  return (
    <Select
      hasShortMultiDisplay
      value={selectedColumns}
      options={options}
      onChange={handleColumnsChange}
      placeholder="Select Columns"
      isClearable={false}
      isMulti
    />
  );
};

export default memo(ColumnSelector);
